import React from 'react';
import ReactDOM from 'react-dom';
import {
  DOMWidgetModel,
  DOMWidgetView,
  ISerializers,
} from '@jupyter-widgets/base';

import { MODULE_NAME, MODULE_VERSION } from '../version';
import { FeatureSpaceView } from './feature-space/FeatureSpaceView';
import { WidgetModelContextProvider } from '@utils/widget-model';
import { FeatureSpace } from '@models/feature-space';
import {
  DomainsDescriptionId,
  JoinDescriptionId,
} from '@models/feature-descriptor-domain';

interface FeatureSpaceWidgetConfig {
  selectable: boolean;
  disabled: boolean;
}

// Python state from feature_space_widget.py
export interface FeatureSpaceWidgetState {
  value: FeatureSpace;
  _selected_joins: JoinDescriptionId[];
  _selected_filters: DomainsDescriptionId[];
  _selected_aggregations: DomainsDescriptionId[];
  configuration: FeatureSpaceWidgetConfig;
}

const defaultState = {
  value: {
    explorationPaths: [],
    filters: { types: [] },
    aggregations: { types: [] },
  },
  _selected_joins: [],
  _selected_filters: [],
  _selected_aggregations: [],
  configuration: { selectable: true, disabled: false },
} satisfies FeatureSpaceWidgetState;

export class FeatureSpaceWidgetModel extends DOMWidgetModel {
  defaults() {
    return {
      ...super.defaults(),
      _model_name: 'FeatureSpaceWidgetModel',
      _model_module: MODULE_NAME,
      _model_module_version: MODULE_VERSION,
      _view_name: 'FeatureSpaceWidgetView',
      _view_module: MODULE_NAME,
      _view_module_version: MODULE_VERSION,
      ...defaultState,
    };
  }

  static serializers: ISerializers = {
    ...DOMWidgetModel.serializers,
  };
}

export class FeatureSpaceWidgetView extends DOMWidgetView {
  render() {
    this.el.classList.add('dotdata-widget');
    this.el.classList.add('feature-space-widget');

    try {
      const component = React.createElement(
        WidgetModelContextProvider(FeatureSpaceView),
        {
          model: this.model,
        }
      );
      ReactDOM.render(component, this.el);
    } catch (e) {
      console.error('FeatureSpaceWidgetView', e);
    }
  }
}
